module.exports = __webpack_public_path__ + "img/31.51d6a94e.png";